const imageRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*\.(jpg|jpeg|png|gif|bmp|jfif|JPG|JPEG|PNG|GIF|BMP|JFIF)(\?[^\s]*)?$/i

export default imageRegex